// src/auth/signUp/WelcomPage.tsx   해당 부분 메인 레이아웃으로 처리 할것 (store 이용)

import { Dispatch, Fragment, SetStateAction, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import * as S from 'auth/signUp/style';
import WelcomeSideImg from 'constants/icon/roouty_img_signup.png';

import { Stack } from 'components/Stack';
import { Button } from 'components/Button';
import { Text } from 'components/Typography';

import Modal from 'components/Modal';
import useWelcomePageModalStore from './welcomPageModalStore';

const WelcomePageContent = (type: TWelcomePageType) => {
  switch (type) {
    case 'Free':
      return (
        <Fragment>
          <Text color="RG02" styleName="headline1">
            회원가입이 완료되었습니다!
          </Text>
          <Text color="RG02" styleName="body2" sx={{ marginTop: '10px' }}>
            루티의 AI 배차 최적화 기능을 무료로 이용해 보세요!
          </Text>
        </Fragment>
      );
    case 'Manager':
      return (
        <Fragment>
          <Text color="RG02" styleName="headline1">
            인증이 완료되었습니다!
          </Text>
          <Text color="RG02" styleName="body2" sx={{ marginTop: '10px' }}>
            매니저님의 이메일 인증이 완료되었습니다.
          </Text>
          <Text color="RG02" styleName="body2" sx={{ marginTop: '8px' }}>
            지금 바로 루티의 다양한 경로 최적화 기능들을 경험해보세요!
          </Text>
        </Fragment>
      );

    default:
  }
};

export const WelcomePage = () => {
  const navigate = useNavigate();
  const { closeModal, pageContentsType } = useWelcomePageModalStore();

  return (
    <Modal
      isModalOpen={true}
      setIsModalOpen={() => {}}
      width={846}
      height={'282px'}
      plain
      ds="strong"
      zIndex={100}
      sx={{ border: 'none' }}
    >
      <S.WelcomePageLayout>
        <Stack
          align="start"
          sx={{
            width: '413px',
            margin: '115px 40px auto 88px',
            position: 'relative',
            bottom: '70px',
            right: '20px',
          }}
        >
          {WelcomePageContent(pageContentsType)}
          <Button
            children="시작하기"
            variant="primary"
            fw
            h={40}
            sx={{ marginTop: '40px', padding: '24px' }}
            onClick={() => closeModal()}
          />
        </Stack>
        <S.WelcomePageSideImg>
          <img src={WelcomeSideImg} alt="WelcomeSideImg" />
        </S.WelcomePageSideImg>
      </S.WelcomePageLayout>
    </Modal>
  );
};
